module.exports = "../../app/cells/pages/landing_xray/index/card_option_cell.rb";